import moment from 'moment'
import formatString from 'format-string-by-pattern'
import abbreviate from 'abbreviate-name'

export const secondsToStringTimer = (sec, noValue = '-') => {
  if (!sec) return noValue
  const d = moment.duration(sec, 'seconds')
  let hours = d.hours()
  hours =
    hours.toString().length < 2 ? '0' + hours.toString() : hours.toString()
  let minutes = d.minutes()
  minutes =
    minutes.toString().length < 2
      ? '0' + minutes.toString()
      : minutes.toString()
  let seconds = d.seconds()
  seconds =
    seconds.toString().length < 2
      ? '0' + seconds.toString()
      : seconds.toString()
  return d.days() > 0
    ? d.days() + 'dias ' + hours + 'h:' + minutes + 'min:' + seconds + 's'
    : hours + 'h:' + minutes + 'min:' + seconds + 's'
}

export const formatSolicitacaoFilterInitialValues = initialValues => {
  return {
    ...initialValues,
    ...(initialValues.analiseDocumentos !== undefined && {
      analiseDocumentos: String(initialValues.analiseDocumentos)
    })
  }
}

export const formatAnaliseDocumentos = analiseDocumentos => {
  return analiseDocumentos ? 'Documentos' : 'Completa'
}

export const formatCpf = cpf => {
  if (cpf && cpf.length === 11) {
    return formatString('XXX.XXX.XXX-XX', cpf)
  }
}

export const formatCnpj = cnpj => {
  if (cnpj && cnpj.length === 14) {
    return formatString('XX.XXX.XXX/XXXX-XX', cnpj)
  }
}

export const formatCpfCnpj = cpfcnpj => {
  return formatCpf(cpfcnpj) || formatCnpj(cpfcnpj)
}

export const formatCurrency = value => {
  if (value === undefined || value === null) {
    return ''
  }
  return Number(value).toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  })
}

export const formatDate = data => {
  if (data) {
    return moment(data).format('DD/MM/YYYY')
  }
  return ''
}

export const formatDateTime = data => {
  if (data) {
    return moment(data).format('DD/MM/YYYY HH:mm:ss')
  }
  return ''
}

export const formatGerenciadora = gerenciadora => {
  switch (gerenciadora) {
    case 'PARANAGR':
      return 'Paraná GR'

    case 'RONDON':
      return 'Rondon'

    case 'ELITE':
      return 'Elite'

    case 'CARGO':
      return 'Cargo'

    default:
      return ''
  }
}

export const formatNomeUsuario = value => {
  if (value) {
    const usuario = value.usuario.split('.')
    usuario.shift()
    return value.nome ? abbreviate(value.nome) : usuario.join(' ')
  }
  return value
}
